import React from "react";
import PropTypes from "prop-types";
import { PiX } from "react-icons/pi";

/**
 * OverlayHeader — reusable header for overlay-system modals and drawers.
 *
 * Replaces the legacy SlideOverHeader (which depends on Redux `state.modal`)
 * with a standalone component that receives all data as props.
 */
export default function OverlayHeader({ title, subtitle, handleClose }) {
  return (
    <div className="sticky z-50 rounded-t-md bg-indigo-700 px-4 py-6 sm:px-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-white">{title}</h2>
        <div className="ml-3 flex h-7 items-center">
          <button
            type="button"
            className="rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
            onClick={handleClose}
          >
            <span className="sr-only">Close panel</span>
            <PiX className="size-6" aria-hidden="true" />
          </button>
        </div>
      </div>
      {subtitle && (
        <div className="mt-1">
          <p className="text-sm text-indigo-300">{subtitle}</p>
        </div>
      )}
    </div>
  );
}

OverlayHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
};

